import React from 'react';
import SignupContainer from 'views/SignupContainer';
import SetNewPasswordForm from 'shared/components/Forms/SetNewPasswordForm';
import { useLocation } from 'react-router-dom';

const SetNewPassword: React.FC = () => {
  const location = useLocation();

  return (
    <SignupContainer>
      <SetNewPasswordForm email={location.state} />
    </SignupContainer>
  );
};

export default SetNewPassword;
